import { render, staticRenderFns } from "./DynamicFormFieldOccupationForm.vue?vue&type=template&id=23af15f4&"
import script from "./DynamicFormFieldOccupationForm.vue?vue&type=script&lang=js&"
export * from "./DynamicFormFieldOccupationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports